export var ContentConsentTypeEnum;
(function (ContentConsentTypeEnum) {
    ContentConsentTypeEnum["TermsAndConditions"] = "TermsAndConditions";
    ContentConsentTypeEnum["DataPermissionsAgreement"] = "DataPermissionsAgreement";
    ContentConsentTypeEnum["PersonalInformationAgreement"] = "PersonalInformationAgreement";
    ContentConsentTypeEnum["ConsentAgreement"] = "ConsentAgreement";
    ContentConsentTypeEnum["CommitmentAgreement"] = "CommitmentAgreement";
    ContentConsentTypeEnum["IndemnityAgreement"] = "IndemnityAgreement";
    ContentConsentTypeEnum["PhotoPermissions"] = "PhotoPermissions";
    ContentConsentTypeEnum["LearningThroughPlay"] = "LearningThroughPlay";
    ContentConsentTypeEnum["PermissionToShare"] = "PermissionToShare";
    ContentConsentTypeEnum["FranchiseeAgreement"] = "Franchisee Agreement";
    ContentConsentTypeEnum["ChildProtection"] = "SmartStarter Information Sheet on Child Protection";
})(ContentConsentTypeEnum || (ContentConsentTypeEnum = {}));
export var ContentTypeEnum;
(function (ContentTypeEnum) {
    ContentTypeEnum[ContentTypeEnum["ProgrammeRoutine"] = 1] = "ProgrammeRoutine";
    ContentTypeEnum[ContentTypeEnum["ProgrammeRoutineItem"] = 2] = "ProgrammeRoutineItem";
    ContentTypeEnum[ContentTypeEnum["ProgrammeRoutineSubItem"] = 3] = "ProgrammeRoutineSubItem";
    ContentTypeEnum[ContentTypeEnum["ProgressTrackingCategory"] = 4] = "ProgressTrackingCategory";
    ContentTypeEnum[ContentTypeEnum["ProgressTrackingSubCategory"] = 5] = "ProgressTrackingSubCategory";
    ContentTypeEnum[ContentTypeEnum["ProgressTrackingLevel"] = 6] = "ProgressTrackingLevel";
    ContentTypeEnum[ContentTypeEnum["ProgressTrackingSkill"] = 7] = "ProgressTrackingSkill";
    ContentTypeEnum[ContentTypeEnum["Theme"] = 8] = "Theme";
    ContentTypeEnum[ContentTypeEnum["ThemeDay"] = 9] = "ThemeDay";
    ContentTypeEnum[ContentTypeEnum["StoryBook"] = 10] = "StoryBook";
    ContentTypeEnum[ContentTypeEnum["StoryBookParts"] = 11] = "StoryBookParts";
    ContentTypeEnum[ContentTypeEnum["StoryBookPartQuestion"] = 12] = "StoryBookPartQuestion";
    ContentTypeEnum[ContentTypeEnum["Activity"] = 13] = "Activity";
    ContentTypeEnum[ContentTypeEnum["Consent"] = 14] = "Consent";
})(ContentTypeEnum || (ContentTypeEnum = {}));
//# sourceMappingURL=content-types.js.map